<template>
  <UPopover v-model:open="isOpen" :content="{ align: 'start' }" mode="hover" >
    <UButton 
      variant="outline" 
      size="lg"
      color="neutral"
      class="font-semibold uppercase tracking-wide"
    >
      <Icon name="i-heroicons-bars-3" class="w-5 h-5 mr-2" />
      <span>{{ $t('Categories') }}</span>
      <!-- <Icon name="i-heroicons-chevron-down" class="w-4 h-4 ml-2" /> -->
    </UButton>

    <template #content>
      <div v-if="categoryStore.loaded" class="p-4 pt-2 min-w-[800px] bg-white dark:bg-gray-900 shadow-lg border border-gray-200 dark:border-gray-700 rounded-lg ">
        <UTabs  color="neutral" variant="link" :items="tabs" class="w-full"  :ui="{
          label: 'uppercase px-2',
        }">
           <template v-for="tab in tabs" :key="tab.slot"  v-slot:[tab.slot]>
            <div class="flex gap-4">
              <div class="p-2 mt-2 grid grid-cols-4 gap-6 flex-1">
                <div v-for="subcat in tab.children" :key="subcat.id" class="space-y-2">
                  <NuxtLink 
                    :to="$localePath({ name: 'category-slug', params: { slug: subcat.slug } })"
                    class="text-sm font-semibold text-gray-900 dark:text-gray-100 hover:underline block"
                    @click="isOpen = false"
                  >
                    {{ subcat.name }}
                  </NuxtLink>
                  <ul class="space-y-1">
                    <li v-for="childCat in subcat.children" :key="childCat.id">
                      <NuxtLink 
                        :to="$localePath({ name: 'category-slug', params: { slug: childCat.slug } })"
                        class="text-sm text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-gray-100 hover:underline transition-colors block"
                        @click="isOpen = false"
                      >
                        {{ childCat.name }}
                      </NuxtLink>
                    </li>
                    <li v-if="subcat.children.length === 0">
                      <NuxtLink 
                        :to="$localePath({ name: 'category-slug', params: { slug: subcat.slug } })"
                        class="text-sm text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-gray-100 hover:underline transition-colors block"
                        @click="isOpen = false"
                      >
                        {{ subcat.name }}
                      </NuxtLink>
                    </li>
                  </ul>
                </div>
              </div>
              
              <!-- Banner functionality - not used at this time -->
              <!-- <div v-if="tab.banner" class="w-80 h-60">
                <CategoryBanner v-bind="tab.banner" />
              </div> -->
            </div>
           </template>
        </UTabs>
      </div>
      <div v-else class="p-4 pt-2  bg-white dark:bg-gray-900 shadow-lg border border-gray-200 dark:border-gray-700 rounded-lg">
        <USkeleton class="h-8 w-100" />
        <USkeleton class="h-8 w-100 my-4" />
        <USkeleton class="h-8 w-100" />
      </div>
    </template>
  </UPopover>
</template>

<script setup lang="ts">
// Banner functionality - not used at this time
// import CategoryBanner from '~/components/molecules/CategoryBanner.vue'
// import type { CategoryBannerType } from '~/components/molecules/CategoryBanner.vue'
const isOpen = ref(false)

const categoryStore = useCategoryStore();

const tabs = computed(() => {
  return buildCategoryTree(categoryStore.categories).map(cat => ({
    label: cat.name,
    slot: cat.slug,
    children: cat.children
    // Banner functionality - not used at this time
    // banner: cat.banner as CategoryBannerType | undefined,
  }));
});

watch(isOpen, (newVal) => {
   if (newVal && !categoryStore.loaded && !categoryStore.pending) {
     categoryStore.load();
   }
});

const {
  locale
} = useI18n();

watch(locale, () => {
  if (categoryStore.loaded) {
    categoryStore.load();
  }
});

// Old static categories import - not used anymore
// import categories from '~~/data/categories';
// const tabs = categories.map(cat => ({
//   label: cat.title,
//   banner: cat.banner as CategoryBannerType | undefined,
//   slot: cat.slug
// }))

</script>
